"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
const react_1 = __importStar(require("react"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const SidebarContext_1 = require("../Sidebar/SidebarContext");
const Menu_1 = require("../../styled/Menu");
const MenuItemRenderer_1 = require("./MenuItemRenderer");
const MenuItemRendererCollapsed_1 = require("./MenuItemRendererCollapsed");
const SubMenuItem_1 = require("./SubMenuItem");
/** Renders a menu with submenus */
const MenuItem = ({ as, ...props }) => {
    const MenuRenderer = (0, react_1.useContext)(SidebarContext_1.SidebarContext).isSidebarCollapsed
        ? MenuItemRendererCollapsed_1.MenuItemRendererCollapsed
        : MenuItemRenderer_1.MenuItemRenderer;
    react_1.default.Children.forEach(props.children, child => {
        if (child?.type !== SubMenuItem_1.SubMenuItem) {
            throw new Error('MenuItem: Only childs of type SubMenuItem allowed!');
        }
    });
    return (react_1.default.createElement(Menu_1.Li, { as: as, ...(0, oxygen_config_1.getTestAttributes)(`${props.testId}_ITEM_${props.label.replaceAll(' ', '-')}`) },
        react_1.default.createElement(MenuRenderer, { ...props })));
};
exports.MenuItem = MenuItem;
